/*Cookies function group*/ 

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }// Function to set Cookie

  function readCookie(name) {
    var nameEQ = name + "=",
      ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];

      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }// Function to read cookie saved

  function allowCookies(name, cvalue, exdays, type) {
    if(typeof OnetrustActiveGroups != 'undefined' && OnetrustActiveGroups.includes("C0003") && type == "C0003") { // Functional Cookies
        setCookie(name, cvalue, exdays);
    } else if(typeof OnetrustActiveGroups != 'undefined' && OnetrustActiveGroups.includes("C0002") && type == "C0002") { // Performance Cookies
        setCookie(name, cvalue, exdays);
    }
  }

  export {setCookie, readCookie, allowCookies}